module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-2-c91297769443ba5869ef57e4abbbe0ab.webp";